export const DEVICES = new Map([
  ["Mobile/Tablet", 1],
  ["PC", 2],
  ["TV", 3],
  ["Phone", 4],
  ["Tablet", 5],
  ["Connected Device", 6],
  ["Set Top Box", 7],
]);
